export default __webpack_public_path__ + "static/media/keto-chocolate-bar.20787da4.png";